export default {
  methods: {
    getBool(arg) {
      return arg === 'true'
    },
    // userAllowed(permissionLevel) {
    //   const userDepartmentId = this.$store.getters.userDepartmentId;
    //   if (!userDepartmentId) return false;
    //   return permissionLevel.split(',').includes(userDepartmentId.toString())
    // },
    userAllowed(permissionLevel) {
      return permissionLevel.split(',').includes(this.$store.getters.userDepartmentId.toString())
    },
    downloadExcel(filename) {
      // שלב 1: העתק את הטבלה
      const originalTable = document.querySelector(".VueTables__table");
      const tableClone = originalTable.cloneNode(true);

      // שלב 2: הסר inputים ו-selectים
      const inputs = tableClone.querySelectorAll("input, select");
      inputs.forEach(input => input.remove());

      // שלב 3: הסר עמודת actions אם קיימת
      if (this.columns && this.columns.includes('actions')) {
        const rows = tableClone.rows;
        for (let i = 0; i < rows.length; i++) {
          rows[i].deleteCell(-1); // מוחק את התא האחרון בכל שורה
        }
      }

      // שלב 4: המרת טבלה ל-Excel
      const workbook = XLSX.utils.table_to_book(tableClone, { sheet: "Sheet1" });

      // שלב 5: הורדה כקובץ xlsx
      XLSX.writeFile(workbook, `${filename}.xlsx`);
    },
  },
}
